export default __webpack_public_path__ + "static/mini-1-01c8fa3189193e7ac3146a88e4573184.png";